// frontend/src/components/citations/GRBASCitation.jsx

import CitationLabel from "./CitationLabel";

export default function GRBASCitation() {
  return (
    <div>
      <CitationLabel>Original instrument</CitationLabel>
      Hirano, M. (1981). <em>Clinical examination of voice</em>. New York:
      {" "}Springer-Verlag.
      <br />
      <br />
    </div>
  );
}